
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z"></path><path d="M12 6a5 5 0 00-3.356 8.707 9.333 9.333 0 00-.929.464c-1.34.766-2.533 1.874-3.525 3.242l1.62 1.174c.424-.586.635-.076.874.501.237.574.502 1.215 1.031.912.635-.363 1.646.067 2.595.471.635.27 1.243.529 1.69.529.467 0 .971-.282 1.477-.565.702-.392 1.407-.787 2.023-.435.514.294.963-.302 1.384-.862.45-.597.87-1.154 1.306-.551l1.62-1.174c-.992-1.368-2.186-2.476-3.525-3.242a9.332 9.332 0 00-.93-.464A5 5 0 0012 6z"></path>
    </svg>
  </template>
  <script>
    export default {
      name: "IconMyFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
